export default __webpack_public_path__ + "static/media/centro_campana.6cc49f87.jpg";